import { useMutation } from 'react-query';
import { createDemand } from 'src/services/api/demands';

function useCreateDemand() {
  return useMutation((data) => createDemand(data));
}

export default useCreateDemand;
